import { render, staticRenderFns } from "./OpsiyonTanimla.vue?vue&type=template&id=4e99bae8&scoped=true&"
import script from "./OpsiyonTanimla.vue?vue&type=script&lang=js&"
export * from "./OpsiyonTanimla.vue?vue&type=script&lang=js&"
import style0 from "./OpsiyonTanimla.vue?vue&type=style&index=0&id=4e99bae8&scoped=true&lang=css&"
import style1 from "./OpsiyonTanimla.vue?vue&type=style&index=1&id=4e99bae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e99bae8",
  null
  
)

export default component.exports